import { render, staticRenderFns } from "./text-message.vue?vue&type=template&id=27c4226d&scoped=true&"
import script from "./text-message.vue?vue&type=script&lang=js&"
export * from "./text-message.vue?vue&type=script&lang=js&"
import style0 from "./text-message.vue?vue&type=style&index=0&id=27c4226d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c4226d",
  null
  
)

export default component.exports